/**
 * 플레이어 화면 구현
 */
import { SbsPlayerGlobal } from '../../../../../common';
import SbsPlayerLogger from '../../../../../utils/logger';

import liveDVRIcon from '../../../../../../assets/controller_live_dvr.svg';
customElements.define(
  'sbs-player-live-dvr',
  class extends HTMLElement {
    constructor() {
      super();

      this.activated = false;
    }

    set activated(value) {
      this._activated = value;
      this.render();
    }
    get activated() {
      return this._activated;
    }

    static get observedAttributes() {
      return [];
    }

    async attributeChangedCallback(name, oldValue, newValue) {
      try {
      } catch (error) {
        console.log(error);
      }
    }

    async connectedCallback() {
      try {
        this.render();
      } catch (error) {
        console.log(error);
      }
    }

    render() {
      try {
        //console.log('## infoType', SbsPlayerGlobal.infoType);

        if (SbsPlayerGlobal.target !== 'live') {
          return;
        }
        this.innerHTML = `<div class="controlToggle-timeMachine${
          this.activated ? ' current' : ''
        }"">
                    <button type="button" class="btnText-timeMachine" aria-label="타임머신 ${
                      this.activated ? '끄기' : '켜기'
                    }">
                      <span class="btnToggle-bar"></span>
                      <span class="text-name">타임머신</span>
                    </button>
                </div>`;
        this.event();
        this.styles();
        this.icons();
      } catch (error) {
        console.log(error);
      }
    }

    event() {
      try {
        this.querySelector('button').addEventListener('click', (event) => {
          this.activated = !this.activated;

          this.dispatchEvent(
            new CustomEvent('button-toggle-live-dvr', {
              detail: this.activated,
            })
          );
        });
      } catch (error) {
        console.log(error);
      }
    }

    styles() {
      try {
      } catch (error) {
        console.log(error);
      }
    }
    icons() {
      try {
        const iconElement = this.querySelector('.iconSvg_timeMachine');
        iconElement?.insertAdjacentHTML('afterbegin', liveDVRIcon);
      } catch (error) {
        console.log(error);
      }
    }
  }
);
